<template>
  <div id="booking-organized-groups">
    <a
      class='book'
      href='javascript:void(0);'
      @click="showModal = true"
    >Бронировать</a>

    <registration-form
      :show-modal="showModal"
      :id="turID"
      :is-individual="isIndividual"
      :date-start="turDateStart"
      :date-end="turDateEnd"

      @close="closeModal"
      @cancel="closeModal"
    ></registration-form>
  </div>
</template>

<script>
	import registrationForm from './Components/RegistrationForm'

	export default {
		name: "booking-organized-groups",
    components: {
	    'registration-form': registrationForm
    },
		data() {
			return {
				turID: orginizedGroupsData.turID,
				isIndividual: orginizedGroupsData.isIndividual,
				turDateStart: orginizedGroupsData.turDateStart,
				turDateEnd: orginizedGroupsData.turDateEnd,
				showModal: false
			}
		},
    methods: {
	    closeModal() {
	    	this.showModal = false;
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Index.vue